import { useMemoizedFn } from 'ahooks'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'
import { gotoLogin } from '@eastcoal/common/utils/route'

import { useAuthStore } from '../useStore'

export const useCheckLogined = () => {
  const { logined } = useAuthStore(state => pick(state, ['logined']))
  const { modal } = useFeedback()

  return useMemoizedFn(() => {
    if (logined) {
      return true
    }
    modal.confirm({
      title: '操作受限',
      content: '该操作需登录，请问是否跳转至登录页面？',
      okText: '前往登录',
      onOk() {
        gotoLogin()
      }
    })
    return false
  })
}
